import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { openTutorialModal } from '../store/actions/dashboardActions'

const STORAGE_KEY = 'edify_welcome_tour_shown'

export const getWelcomeTourShown = (): string | null => {
  if (typeof window === 'undefined') return null
  return localStorage.getItem(STORAGE_KEY)
}

export const setWelcomeTourShown = (value: 'completed' | 'skipped') => {
  if (typeof window === 'undefined') return
  localStorage.setItem(STORAGE_KEY, value)
}

export const shouldAutoShowWelcomeTour = (): boolean => {
  return getWelcomeTourShown() === null
}

export const useWelcomeTour = () => {
  const dispatch = useDispatch()

  const openFromFaq = useCallback(() => {
    dispatch(openTutorialModal())
  }, [dispatch])

  return { openFromFaq }
}
